import React, { useEffect, useState } from 'react';
import SearchItemBlock from '../../shared/SearchItemBlock';
import { Pagination } from '../Pagination';
import { useTranslation } from 'react-i18next';
import { recipesStorageInstance as recipesStorage } from '../../services/recipesStorage';
import useWindowDimensions from '../../hooks/useWindowDimension';
import { productsStorage } from '../../services/productsStorage';
import DeleteRecipePopup from './DeleteRecipePopup';
import RecipesList from './RecipesList';
import RecipeTable from './RecipeTable';
import CreateNewRecipePopup from './CreateNewRecipePopup';
import CreateNewRecipeButton from './CreateNewRecipeButton';
import DownloadRecipesCsvButton from './DownloadRecipesCsvButton';
import { useListViewMode } from '../../shared/listView/useListViewMode';
import ListViewSwitcher from '../../shared/listView/ListViewSwitcher';

const RecipesListTab = () => {
    const { i18n } = useTranslation();
    const { width } = useWindowDimensions();
    const { mode, setMode, isTableForcedOff } = useListViewMode('recipe');
    const [revision, setRevision] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const reloadRecipes = () => {
        recipesStorage.loadItems(() => setRevision((value) => value + 1), width);
    };

    useEffect(() => {
        const onChange = () => {
            setIsLoading(false);
            setRevision((value) => value + 1);
        };
        productsStorage.loadItems(() => {
            recipesStorage.loadFilters(i18n, () => {
                recipesStorage.loadItems(onChange, width);
            });
        }, width);
        recipesStorage.registerFiltersChangingObserver(onChange);

        return () => {
            recipesStorage.unRegisterFiltersChangingObserver(onChange);
            recipesStorage.setPageNumber(1);
        };
    }, []);

    const items = mode === 'table'
        ? recipesStorage.getItems(true)
        : recipesStorage.getItems();

    return (
        <>
            <DeleteRecipePopup notifyRecipesList={reloadRecipes} />
            <CreateNewRecipePopup />
            <SearchItemBlock
                itemsStorageService={recipesStorage}
                placeholder={i18n.t('app.page.recipe.recipeSearch')}
                actions={
                    <>
                        <CreateNewRecipeButton />
                        <DownloadRecipesCsvButton />
                        <ListViewSwitcher
                            mode={mode}
                            onChange={setMode}
                            disabled={isTableForcedOff}
                        />
                    </>
                }
            />
            <article className="recipe__article-item">
                {mode === 'table' ? (
                    <RecipeTable key={`table-${revision}`} items={items} isLoading={isLoading} />
                ) : (
                    <RecipesList key={`tile-${revision}`} items={items} isLoaded={!isLoading} />
                )}
            </article>
            {mode === 'tile' ? <Pagination itemsStorageService={recipesStorage} /> : null}
        </>
    );
};

export default RecipesListTab;
